// extracted by mini-css-extract-plugin
export default {"socialLink":"socials__socialLink__PkUdu","socialIcon":"socials__socialIcon__EylfH"};